import axios from "axios";

export default axios.create({
  baseURL: "https://lmsdemo.aeonsoftware.net/cit",
});
